import type { Database } from '@aikoa/common'
import 'react-native-url-polyfill/auto'
import { createClient } from '@supabase/supabase-js'
import { Platform } from 'react-native'
import { env } from '~/env'
import { appFetch } from '~/lib/fetch'

const supabaseUrl = env.EXPO_PUBLIC_SUPABASE_URL
const supabaseAnonKey = env.EXPO_PUBLIC_SUPABASE_PUBLISHABLE_KEY

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: Platform.OS === 'web',
  },
  global: {
    fetch: appFetch,
  },
})
